import { z } from "zod";
import { schemes } from "@zeal/common";

export const createInstantPayPayoutRequestSchema = z.object({
  companyID: schemes.uuid(),
});

export const createInstantPayPayoutResponseSchema = z.object({
  success: z.boolean(),
  payout_transaction_id: z.string().optional(),
  amount: z.number(),
  charge_count: z.number(),
  transaction_id: z.string().optional(),
  message: z.string().optional(),
});

export const createInstantPayPayoutResponseWrapperSchema = z.object({
  success: z.boolean(),
  testMode: z.boolean(),
  data: createInstantPayPayoutResponseSchema,
});

export type TCreateInstantPayPayoutRequest = z.infer<
  typeof createInstantPayPayoutRequestSchema
>;
export type TCreateInstantPayPayoutResponse = z.infer<
  typeof createInstantPayPayoutResponseWrapperSchema
>;
